import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getTransactionAction } from 'redux/reducers/apiReducers/getTransactionReducer'
import { screenLoadingAction } from 'redux/actions'
import { useSelector } from 'react-redux'

const ReceiveConfirmationView = ({ t, i18n, setIsError }) => {
  const dispatch = useDispatch()
  let history = useHistory()
  const { transId, transOwner } = useParams()
  const emailAddress = useSelector((state) => state.driver.driverInformation.emailAddress)

  useEffect(() => {
    try {
      dispatch(screenLoadingAction())
      dispatch(getTransactionAction(transId))
        .then((res) => {
          dispatch(screenLoadingAction())
          let fulfillmentStatus = res['data']['fulfillmentStatus']
          i18n.changeLanguage(res['data']['lang'])
          if (fulfillmentStatus === 'PAYMENTSUCCEEDED' && res['data']['paymentTransactionNum']) {
            history.push({
              pathname: `/${i18n.language}${t('routes.confirmation')}`,
              state: {
                transNum: res['data']['paymentTransactionNum'],
                transId: transId,
                emailAddress: emailAddress,
                transOwner: transOwner,
              },
            })
          } else if (fulfillmentStatus === "SENTFORPAYMENT") {
            history.push(`/${i18n.language}${t('routes.review_confirmation')}?fulfillmentStatus=SENTFORPAYMENT`)
          } else {
            history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
          }
        })
        .catch((e) => {
          console.log(e)
          setIsError(true)
          dispatch(screenLoadingAction())
        })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  return <div className="container"></div>
}

export default withTranslation('common')(ReceiveConfirmationView)
